import { render, staticRenderFns } from "./LoadplanVersion.vue?vue&type=template&id=1fdb80bc&scoped=true"
import script from "./LoadplanVersion.vue?vue&type=script&lang=ts"
export * from "./LoadplanVersion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdb80bc",
  null
  
)

export default component.exports